import { Shell } from '@components/Shell/Shell'
import { ScrollRestoration } from 'react-router-dom'

export const BaseLayout = (): JSX.Element => {
  return (
    <>
      <Shell />
      <ScrollRestoration />
    </>
  )
}
